import { ApiGame, ApiSeat } from "../../src/types/apigame";
import UserPlayerAvatar, { UserPlayerAvatarSize } from "./playeravatar";

interface UserSeatArgs {
    game?: ApiGame;
    seatObject: ApiSeat;
    size?: UserPlayerAvatarSize;
    userId: number;
    disableAcceptedDimming?: boolean;
}

export default function UserSeat(
    {
        game,
        seatObject,
        size,
        userId,
        disableAcceptedDimming,
    }: UserSeatArgs,
) {
    const name = seatObject.userId === userId ? 'you' : seatObject.name;

    return <>
        <UserPlayerAvatar
            game={game}
            seatObject={seatObject}
            showProfileOnClick={false}
            size={size}
            disableAcceptedDimming={!!disableAcceptedDimming}
        />
        <span>
            &nbsp;
            {name}
        </span>
    </>;
}
